import React from 'react';
import { useSelector } from 'react-redux';
import UserDateFormat from '../../../../user-date-format/index';
import Global from '../../../../../store/global-selectors';

const CreatedDateColumn = ({ fulfillmentPlanSetId }) => {
  const fulfillmentPlanSet = useSelector((state) =>
    Global.selectEntitiesFulfillmentPlanSetById(state, {
      fulfillmentPlanSetId,
    }),
  );
  const { createDate } = fulfillmentPlanSet ?? {};

  if (!createDate) {
    return '';
  }

  return <UserDateFormat value={createDate} />;
};

export default {
  id: 'batch-created-date',
  messageDescriptorKey: 'createdDate',
  orderByParam: 'CreatedDate',
  width: 130,
  render: ({ fulfillmentPlanSetId }) => <CreatedDateColumn fulfillmentPlanSetId={fulfillmentPlanSetId} />,
};
